export var DomainACL;
(function (DomainACL) {
    let ACLAction;
    (function (ACLAction) {
        ACLAction["ALLOW"] = "ALLOW";
        ACLAction["BLOCK"] = "BLOCK";
    })(ACLAction = DomainACL.ACLAction || (DomainACL.ACLAction = {}));
})(DomainACL || (DomainACL = {}));
